import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const useAnimation = (refs: React.RefObject<HTMLElement>[]): [fadeout: React.RefObject<GSAPTween | undefined>, fadein: React.RefObject<GSAPTween | undefined>] => {

  const fadeout = useRef<GSAPTween>();
  const fadein = useRef<GSAPTween>();

  useEffect(() => {
    const defaults = {
      duration: 0.7,
      ease: "power2.inOut",
      stagger: 0.1
    };

    const doms: HTMLElement[] = [];
    refs.forEach(ref => ref.current && doms.push(ref.current));

    fadeout.current = gsap.fromTo(doms, { x: 0, opacity: 1 }, {
      ...defaults,
      x: -20,
      opacity: 0
    }).pause();

    fadein.current = gsap.fromTo(doms.reverse(), { x: 20, opacity: 0 }, {
      ...defaults,
      x: 0,
      opacity: 1
    }).pause();


    return () => {
      fadeout.current?.kill();
      fadein.current?.kill();
    }
  }, []);

  return [fadeout, fadein];
}

export default useAnimation;